import { render, staticRenderFns } from "./CountryOverviewTable.vue?vue&type=template&id=de867a7c&"
import script from "./CountryOverviewTable.vue?vue&type=script&lang=js&"
export * from "./CountryOverviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports